/* eslint-disable */
// Central catalog of every game in the Zombie Arcade. Add a new entry here
// and the homepage + nav update automatically. Keep `route` matching the
// React Router path so links stay in sync.
import { Crosshair, Spade, Grid3x3, Combine, Castle, Building2 } from "lucide-react";

export const GAMES = [
  {
    id: "zombie-collector-3d",
    title: "Zombie Collector 3D",
    tagline: "UFO tractor-beam runs through endless zombie waves",
    status: "live",
    featured: true,
    route: "/games/zombie-collector-3d",
    icon: Crosshair,
    // Visual identity — used to colour the card. Matches the in-game palette.
    accent: "#7ed957",
    accent2: "#c2ff5d",
    blurb: "Pilot a UFO, vacuum up zombies, survive endless waves. Unlock 11 worlds, talents, cosmetics, and climb the global leaderboard.",
  },
  {
    id: "zombie-solitaire",
    title: "Zombie Solitaire",
    tagline: "Klondike with a graveyard twist",
    status: "live",
    route: "/games/zombie-solitaire",
    icon: Spade,
    accent: "#a569ff",
    accent2: "#e0aaff",
    blurb: "Classic Klondike Solitaire reimagined with zombie-themed cards, graveyard tableau, and spooky animations.",
  },
  {
    id: "zombie-crush",
    title: "Zombie Crush",
    tagline: "Match-3 with brains, skulls, and antidotes",
    status: "live",
    route: "/games/zombie-crush",
    icon: Grid3x3,
    accent: "#ff5b6b",
    accent2: "#ffb347",
    blurb: "Match brains, skulls, zombies and antidotes to clear levels. Combos unlock special zombie pieces and chain reactions.",
  },
  {
    id: "zombie-merge",
    title: "Zombie Merge",
    tagline: "Merge zombies, unlock mutations",
    status: "live",
    route: "/games/zombie-merge",
    icon: Combine,
    accent: "#5ee8ff",
    accent2: "#84e6ff",
    blurb: "Slide identical zombies together to evolve them into stronger horrors. Reach the Zombie King to win. 2048 with brains.",
  },
  {
    id: "zombie-tycoon",
    title: "Zombie Idle Tycoon",
    tagline: "Build a zombie empire, idle for gold",
    status: "live",
    route: "/games/zombie-tycoon",
    icon: Building2,
    accent: "#ffd66b",
    accent2: "#7ed957",
    blurb: "Build huts, labs, mines and 11 more zombie facilities. Hire undead workers, upgrade structures, and watch the gold roll in even when you're away.",
  },
  {
    id: "zombie-tower-defense",
    title: "Zombie Tower Defense",
    tagline: "Defend survivor camps, wave by wave",
    status: "coming-soon",
    route: "/games/zombie-tower-defense",
    icon: Castle,
    accent: "#ffb347",
    accent2: "#ffd06b",
    blurb: "Place towers, traps, and upgrades to stop zombie hordes from reaching your survivor camp. Endless tactical strategy.",
  },
];

export function getGameById(id) {
  return GAMES.find((g) => g.id === id);
}

export function getGameByRoute(route) {
  return GAMES.find((g) => g.route === route);
}
